<section class="stc-venta-exitosa banner-padding">

  <div class="container">

    <div class="row sub-headers-inside sub-inside">





      <div class="col-12 m-auto text-center">

        <div class="overlap-signature header-inside">

          <span class="letter"> <span class="signature-text">Gracias por </span></span>

          <h1 class="main-text">tu apoyo</h1>

        </div>

      </div>





    </div>

  </div>

  <a (click)="scrollPage('#orden')" class="cta-bottom d-md-block d-none">

    <img src="/assets/img/sorteo2023/arrow-bottom.png" class="img-fluid">

  </a>

</section>



<!-- SECCIÓN 2: CONTENIDO PRINCIPAL -->
<section class="venta-ext" id="orden">
  <div class="container " data-aos="fade-up">

    <!-- CASO: ÉXITO -->
    <div class="row justify-content-center bg-white shadow-sm p-1 rounded"
      *ngIf="request.nbResponse == 'Aprobado' || (reqBanamex.resultIndicator != undefined && reqBanamex.resultIndicator == orden_banamex)">

      <div class="col-lg-10 text-center">
        <!-- Encabezado de Éxito -->
        <h3 style="color: #ff4700; font-weight: 700; font-size: 36px;">{{textoInt}}</h3>
        <h2 class="mb-4" style="font-size: 28px; text-transform: uppercase;">¡Compra exitosa!</h2>

        <div class="alert alert-success bg-light border-0 mb-4">
          <p class="mb-0" style="font-size: 18px;">
            Recibirás la información en tu correo (revisa spam). <br>
            También puedes ver tus boletos en tu wallet:
            <a [href]="urlWeb" target="_blank" class="font-weight-bold"
              style="color: #f35f44; word-break: break-all; overflow-wrap: break-word;">
              {{urlWeb}}
            </a>
          </p>
        </div>

        <!-- Tabla de Boletos (Desktop-friendly con Scroll) -->
        <div class="BoletosPay my-4" *ngIf="boletos && noData">
          <h5 class="text-muted mb-3">Resumen de tus boletos ({{ boletos.length }})</h5>
          <div class="table-responsive shadow-sm rounded">
            <table class="table table-hover align-middle mb-0">
              <thead style="background-color: #f8f9fa;">
                <tr>
                  <th class="texto-primario border-0">No. Boleto</th>
                  <th class="texto-primario border-0">Dueño</th>
                  <th class="texto-primario border-0">Correo</th>
                  <th class="texto-primario border-0">Costo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let boleto of boletos">
                  <td class="font-weight-bold">{{ boleto.folio }}</td>
                  <td>{{ boleto.nombre_comprador }}</td>
                  <td>{{ boleto.correo_comprador }}</td>
                  <td class="text-success">$ {{ boleto.costo }} MXN</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Acciones: Descargas y Visualización -->
        <div class="row mt-4 gy-3">
          <div class="col-md-6">
            <div class="card h-100 border-0 bg-light p-3">
              <button  (click)="verBoletosTabla()" class="btn-stack w-100 border-0">
                <i class="fas fa-ticket-alt mr-2"></i> Ver mis boletos
              </button>
<!-- 
              <div *ngIf="isLoading" class="py-2">
                <span class="spinner-border spinner-border-sm text-primary"></span> Cargando...
              </div> -->

              <div  class="small mt-2 text-muted">
                <strong>¿No los ves?</strong> Revisa tu Wallet o el correo de confirmación.
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card h-100 border-0 bg-light p-3" *ngIf="boletos && boletos.length > 0">
              <button class="btn-stack w-100 border-0" (click)="descargarTodosLosBoletos()"
                [disabled]="intentosDescarga >= MAX_INTENTOS">
                <i class="fa fa-download mr-2"></i>
                {{ (intentosDescarga >= MAX_INTENTOS) ? 'Límite alcanzado' : 'Descargar todos' }}
              </button>
              <p class="small mt-2 mb-0" [style.color]="intentosDescarga >= MAX_INTENTOS ? 'red' : 'orange'">
                Intentos: {{ intentosDescarga }} / {{ MAX_INTENTOS }}
              </p>
            </div>
          </div>
        </div>

        <!-- Reserva para el futuro -->


        <!-- Datos Técnicos del Pago -->
        <div class="mt-5 pt-4 border-top text-left small text-muted bg-light p-3 rounded">
          <div class="row">
            <div class="col-sm-6">
              <p class="mb-1"><strong>Orden:</strong> {{ request.referencia }}</p>
              <p class="mb-1"><strong>Monto:</strong> ${{ request.importe }} MXN</p>
            </div>
            <div class="col-sm-6 text-sm-right">
              <p class="mb-1">Pago recibido con éxito</p>
            </div>
          </div>
        </div>

        <div class="mt-5 p-3 border rounded bg-white">
          <div class="custom-control custom-checkbox d-inline-block">
            <input type="checkbox" class="custom-control-input" id="checkPerpetuo" (click)="MarcarBoleto()">
            <label class="custom-control-label font-weight-bold" for="checkPerpetuo" style="cursor:pointer">
              Quiero reservar este(os) número(s) para futuros sorteos
            </label>
          </div>
          <p class="text-muted mt-2 small">¡Gracias por participar y mucha suerte!</p>
        </div>

        <!-- Botones de Salida -->
        <div class="row mt-5">
          <div class="col-md-6 mb-3">
            <button (click)="terminar()" class="btn btn-outline-secondary btn-block py-3">Seguir comprando</button>
          </div>
          <div class="col-md-6 mb-3">
            <button (click)="terminar()" class="btn-stack btn-block py-3 border-0">Terminar proceso</button>
          </div>
        </div>

      </div>
    </div>

    <!-- CASO: ERROR -->
    <div class="row justify-content-center mt-4"
      *ngIf="request.nbResponse != 'Aprobado' && reqBanamex.resultIndicator == undefined">
      <div class="col-md-8 text-center bg-white shadow p-5 rounded">
        <div class="mb-4">
          <i class="fas fa-exclamation-circle text-danger fa-4x"></i>
        </div>
        <h2 class="texto-primario mb-4" style="font-weight: 700;">Transacción no exitosa</h2>

        <div class="alert alert-danger">
          <label *ngIf="request.nbResponse == 'Rechazado'">Lo sentimos, el pago ha sido rechazado por su banco.</label>
          <label *ngIf="request.nbResponse == 'Invalido'">Uno o varios boletos ya no están disponibles. Favor de
            intentar nuevamente.</label>
          <label *ngIf="request.nbResponse == 'Bloqueo'">Hubo un error al generar tu pago. Por favor intenta de
            nuevo.</label>
          <label *ngIf="request.nbResponse == null">Algo salió mal. Por favor, inténtalo nuevamente.</label>
        </div>

        <button (click)="terminar()" class="btn-stack border-0 px-5 py-3 mt-4">Regresar e intentar de nuevo</button>
      </div>
    </div>

  </div>
</section>
